import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import SEO from '../components/SEO';
import GroupCompaniesLandingPage from './GroupCompaniesLandingPage';
import AscariiServiceHours from './AscariiServiceHours';
import MotorFactorsLanding from './MotorFactorsLanding';
import AscariiGoLanding from './AscariiGoLanding';
import BuildersMerchantsLanding from './BuildersMerchantsLanding';
import PlumbersMerchantsLanding from './PlumbersMerchantsLanding';
import TimberMerchantsLanding from './TimberMerchantsLanding';
import GardenCentresLanding from './GardenCentresLanding';
import PartnerTransferLanding from './PartnerTransferLanding';
import SignpostLanding from './SignpostLanding';
import NeworMoveLanding from './NeworMoveLanding';
import axios from 'axios';

import AscariiRunV2Landing from './AscariiRunV2Landing';

const LandingPageRenderer = () => {
  const { slug } = useParams();
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    checkPage();
  }, [slug]);

  const checkPage = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/portal/landing-pages/${slug}/check`);
      setPageData(response.data);
    } catch (error) {
      if (error.response?.status === 403) {
        setError('This landing page is currently inactive.');
      } else if (error.response?.status === 404) {
        setError('Landing page not found.');
      } else {
        setError('Unable to load landing page.');
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  if (error) return <div className="min-h-screen flex items-center justify-center text-xl text-gray-600">{error}</div>;

  // Add dynamic SEO for the landing page
  const seoTitle = pageData?.title || 'Landing Page';
  const seoDescription = pageData?.meta_description || pageData?.description || 'SAP Business One solution by Ascarii';

  // Route to specific landing pages - they handle their own SEO
  if (slug === 'ascariirun') {
    return <AscariiRunV2Landing />;
  }

  if (slug === 'group-companies-sap-business-one-aws') {
    return <GroupCompaniesLandingPage />;
  }
  
  if (slug === 'ascarii-service-hours') {
    return <AscariiServiceHours />;
  }
  
  if (slug === 'motor-factors-landing') {
    return <MotorFactorsLanding />;
  }
  
  if (slug === 'ascarii-go') {
    return <AscariiGoLanding />;
  }
  
  if (slug === 'builders-merchants') {
    return <BuildersMerchantsLanding />;
  }
  
  if (slug === 'plumbers-merchants') {
    return <PlumbersMerchantsLanding />;
  }
  
  if (slug === 'timber-merchants') {
    return <TimberMerchantsLanding />;
  }
  
  if (slug === 'garden-centres') {
    return <GardenCentresLanding />;
  }
  
  if (slug === 'partner-transfer') {
    return <PartnerTransferLanding />;
  }
  
  if (slug === 'signpost') {
    return <SignpostLanding />;
  }
  
  if (slug === 'newormove') {
    return <NeworMoveLanding />;
  }

  // Default for other slugs with dynamic SEO
  return (
    <div className="min-h-screen flex items-center justify-center">
      <SEO 
        title={seoTitle}
        description={seoDescription}
        keywords={`SAP Business One, ${slug.replace(/-/g, ' ')}, Ascarii`}
        canonical={`https://www.ascarii.com/landing/${slug}`}
      />
      <div className="text-xl text-gray-600">Landing page template not configured</div>
    </div>
  );
};

export default LandingPageRenderer;
